import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container } from "react-bootstrap";
import { Helmet } from "react-helmet";
import PageSEO from "../Components/PageSEO";
import ScrollReveal from "../Components/ScrollReveal";

const faqs = [
  {
    id: 1,
    question: "How early should I arrive?",
    answer:
      "We recommend arriving at least 20–30 minutes early. This gives you plenty of time to check in or purchase tickets. Arriving late risks missing the beginning of an award-winning tour — and we can't have that!",
  },
  {
    id: 2,
    question: "Will there still be a tour if the weather is bad?",
    answer:
      "Yes! Tours go on rain or shine, and we highly recommend wearing appropriate attire. Bust out those rain boots! In the case of something catastrophic — a tornado or shoulder-high flood — we'll contact you to reschedule before you risk your life.",
  },
  {
    id: 3,
    question: "...but it's raining!",
    answer:
      "Umbrellas are pretty nifty and quite useful in the event of rain. Did you know the first recorded use of an umbrella was in 21 AD? Seriously, we suggest investing in one. You could always opt for the trendier poncho as well.",
  },
  {
    id: 4,
    question: "Can kids come on the tour?",
    answer:
      "We offer over a dozen different tours, each with its own unique offering. Please check each individual tour page for details. Some tours are off limits to those 21 and under.",
  },
  {
    id: 5,
    question: "Is the tour stroller friendly?",
    answer:
      "This can vary depending on the tour. See each individual tour page for additional details.",
  },
];

const getSchema = () => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.question,
    acceptedAnswer: { "@type": "Answer", text: f.answer },
  })),
});

const FAQItem = ({ faq }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="faq-item">
      <button
        className="faq-item__question"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
      >
        <span>{faq.question}</span>
        <span className={`faq-item__icon${open ? " faq-item__icon--open" : ""}`}>+</span>
      </button>
      {open && <div className="faq-item__answer">{faq.answer}</div>}
    </div>
  );
};

const FAQ = () => {
  return (
    <>
      <PageSEO
        title="Frequently Asked Questions | American Legacy Tours"
        description="Have questions about American Legacy Tours? Find answers about meeting points, accessibility, cancellation policies, what to wear, and more before your tour."
        path="/faq"
        schema={getSchema()}
      />

      <div
        className="faq-hero"
        style={{ backgroundImage: "url('https://res.cloudinary.com/american-legacy-tours/image/upload/c_fill,h_500,w_1800/f_auto,q_auto/img/home/slider/slider-03')" }}
      >
        <div className="faq-hero__overlay" />
        <Container>
          <h1>Frequently Asked Questions</h1>
          <p>Everything you need to know before your tour.</p>
        </Container>
      </div>

      <div className="faq-body">
        <Container style={{ maxWidth: 760 }}>
          {faqs.map((faq, i) => (
            <ScrollReveal key={faq.id} delay={i * 55}>
              <FAQItem faq={faq} />
            </ScrollReveal>
          ))}

          <ScrollReveal delay={faqs.length * 55 + 40}>
            <div
              style={{
                marginTop: 40,
                textAlign: "center",
                background: "var(--brand-dark)",
                borderRadius: 8,
                padding: "32px 24px",
                color: "#fff",
              }}
            >
              <p style={{ margin: "0 0 16px", fontSize: "1.05rem" }}>
                Still have questions? We're happy to help.
              </p>
              <a href="/contact-us" className="btn-brand">Contact Us</a>
            </div>
          </ScrollReveal>
        </Container>
      </div>
    </>
  );
};

export default FAQ;
